import React from "react"
import { Box } from "@mui/material"
import { COLORS } from "../../utils"


const PECellValue = ({
  value1,
  value2,
  unit,
  style = { color: COLORS.BLACK_500}
}) => {
  if (!value1 && !value2) return "-"

  const fixedStyle = {whiteSpace: "nowrap", ...style}
  return (
    <Box
      sx={{
        display: "inline",
        whiteSpace: "normal",
        wordBreak: "break-word",
      }}
    >
      {value1 && value2 ? `${value1} / ${value2}` : (value1 || value2 || "")}
      <span style={fixedStyle}> {unit}</span>
    </Box>
  )
}

export default PECellValue